import {
  useWorkflowOne,
  generateWfOnePdfReportbyId,
} from "../../../../../libs/apis";
import { ShowContainer } from "../../../../../components/workflow-one/components/list/show-container";
import { WorkflowProcessTable } from "./workflow-process-table";

const useWorkflowOneList = (params: Parameters<typeof useWorkflowOne>[0]) =>
  useWorkflowOne(params).workflowOnesQuery;

const WorkflowOneListComponent = () => (
  <WorkflowProcessTable
    useList={useWorkflowOneList}
    generatePdf={generateWfOnePdfReportbyId}
    type="one"
    number={1}
    ShowContainer={ShowContainer}
  />
);

export default WorkflowOneListComponent;
